import React from 'react'
import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'

export default function Pagination({ currentPage, setCurrentPage, totalPages, customClass = '' }) {
    const next = () => {
        if (currentPage === totalPages) return
        setCurrentPage(currentPage + 1)
    }

    const prev = () => {
        if (currentPage === 1) return
        setCurrentPage(currentPage - 1)
    }

    return (
        <nav className={`flex items-center gap-4 ${customClass}`} aria-label="Pagination">
            <button
                type="button"
                className="nx-btn-secondary p-2"
                onClick={prev}
                disabled={currentPage === 1}
                aria-label="Previous page"
            >
                <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" />
            </button>
            <span className="font-mono text-xs text-muted">
                Page <strong className="text-paper">{currentPage}</strong> of{' '}
                <strong className="text-paper">{totalPages}</strong>
            </span>
            <button
                type="button"
                className="nx-btn-secondary p-2"
                onClick={next}
                disabled={currentPage === totalPages}
                aria-label="Next page"
            >
                <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
            </button>
        </nav>
    )
}
